import { render } from "./Sql.vue?vue&type=template&id=a01e5ce2&scoped=true"
import script from "./Sql.vue?vue&type=script&lang=ts"
export * from "./Sql.vue?vue&type=script&lang=ts"

import "./Sql.vue?vue&type=style&index=0&id=a01e5ce2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a01e5ce2"

export default script